/**
 * Document Blocks Hooks
 * Barrel file for document block hooks
 */

export { useDocumentMutations } from './UseDocumentMutations'
export type {
	CreateSectionData,
	UpdateSectionData,
	UpdateDocumentData,
	DocumentMutations,
} from './UseDocumentMutations'
